module.exports = __webpack_public_path__ + "img/CM-PW-24-Kia-Established.1d356ce7.jpg";